/**
 * Created by shiyonggao on 2019/1/22.
 */
import $_ from "lodash";

const  state = {};
const handle = {
    /**
     * 支付成功
     * @param state
     * @param rootState
     * @param commit
     * @param dispatch
     * @param res
     * @param agrs
     */
    orderSuccessCallback(state, commit, dispatch, rootState, res, agrs) {
        let url = '';
        let lang = rootState.$common.lang2[rootState.$appConfig.PARAMS.lang];

        //本页面弹窗显示
        if (agrs.channel['channel_redirect_type'] === 'popup') {
            let number = agrs.channel['channel_redirect_size'].split('_');
            url = rootState.$appConfig.orderCallbackUrl.replace('@oid@', res.result['order_id']);
            url = url + `&lang=${lang}`;
            //弹出层处理
            dispatch('$POP_SHOW_HANDLE', {
                show: true,
                isIframe: true,
                title: agrs.channel['channel_name'],
                iframeUrl: url,
                iframeWH: {
                    height: number[1],
                    width: number[0],
                },
                callback($state, popDeflaut) {
                    commit('LOADING', false, {root: true});
                }
            }, {root: true});
            return;

        }
        

        //在新窗口打开页面
        url = rootState.$appConfig.orderCallbackUrl.replace('@oid@', res.result['order_id']);
        url = url + `&lang=${lang}`;
        window.open(url);
        commit('LOADING', false, {root: true});
    },

    /**
     * 支付400错误失败
     * @param state
     * @param rootState
     * @param commit
     * @param dispatch
     * @param res
     * @param agrs
     */
    orderErrorCode400Callback(state, commit, dispatch, rootState , res, agrs){
        let message = JSON.parse(res['message']);

        //forbidden_channel_show=》封禁渠道显示
        if (message['error_code'] === 'forbidden_channel_show') {
            console.log(`${message['error_code']}=》封禁渠道显示`);
            message['error_code']  = 'forbidden_placed_order';
            console.log(`forbidden_channel_show To: ${message['error_code']}=》封禁渠道显示`);
        }

        let desc = rootState.$lang[message['error_code']] ?
            rootState.$lang[message['error_code']] : rootState.$lang['forbidden_channel_pay'];

        //弹出层处理
        dispatch('$POP_SHOW_HANDLE',{
            show: true,
            title: rootState.$lang.tips_text,
            desc: desc,
            callback($state, popDeflaut) {

                //forbidden_access_page=》跳转到不可访问支付页面的提示页面
                //pay_reversal=》跳转到还款的页面
                //pay_not_reversal=》跳转到不可还款的页面
                if (rootState.$common.repaymentJumpTo(rootState.$appConfig, message['error_code'])) {
                    $state.$popStatus = popDeflaut;
                    return;
                }
                $state.$popStatus = popDeflaut;
            }
        },{root : true});
        commit('LOADING', false, {root: true});
    },
    /**
     * 获取当前域名所有cookie
     */
    getAllCookie() {
        let cookies = document.cookie;
        let allCookiesArr = cookies.split('; ');
        let cookieObj = {};
        for (let key in allCookiesArr) {
            if (allCookiesArr[key]) {
                let item = allCookiesArr[key].split('=');
                cookieObj[item[0]] = decodeURIComponent(item[1]);
            }
        }

        return cookieObj;
    },
};

const actions = {
    /**
     * 用户提交订单操作
     * @param state
     * @param commit
     * @param dispatch
     * @param rootState
     * @param agrs
     * @constructor
     */
    SUBMIT({state, commit, dispatch, rootState}, agrs){

        //无角色提示
        if (!agrs.selectedUserData) {
            //alert(agrs.$lang['select_user_not_user_tip']);
            dispatch('$POP_SHOW_HANDLE', {
                show: true,
                title: agrs.$lang.tips_text,
                desc: agrs.$lang['select_user_not_user_tip'],
                callback($state, popDeflaut) {
                    $state.$popStatus = popDeflaut;
                }
            }, {root: true});
            return false;
        }

        //用户自定义参数
        let optional_params = {
            lang : rootState.$common.lang2[rootState.$appConfig.PARAMS.lang]
        };


        let version = rootState.$appConfig.getVersionInfo();
        let url = version.api.app_base_url + version.api.app_order;
        let params = {
            amount_id: agrs.selectedPackageData.amount_id,
            product_id: agrs.selectedPackageData['amount_product_id'],
            merchant_shop_server_id: agrs.selectedServerData['server_sid'],
            user_id: rootState.$appConfig.PARAMS.user_id,
            merchant_shop_server_type: agrs.selectedServerData['server_type'],
            user_role: agrs.selectedUserData.name,
            user_role_id: agrs.selectedUserData['roleid'],
            user_role_level: agrs.selectedUserData.level,
            ad_source: rootState.$appConfig.PARAMS.ad_source,
            optional_params: JSON.stringify(optional_params)
        };
         /**
         * 添加cookie信息
         */
        let cookies = handle.getAllCookie();
        let data = rootState.$lodash['merge']({}, cookies, params);
        commit('LOADING', true ,{root:true});
        rootState.$common.ajax({
            url: url,
            type: 'post',
            data: data,
            success: function (res) {
                if (res.code === 200) {
                    if(res.message === 'success'){
                        handle.orderSuccessCallback(state, commit, dispatch, rootState, res, agrs);
                    }

                }
            },
            error(res) {
                res = JSON.parse(res.responseText);
                if (res.code === 400) {
                    handle.orderErrorCode400Callback(state, commit, dispatch,rootState, res, agrs);
                }
            }
        });
    }
};
const mutations = {};
const getters = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




// WEBPACK FOOTER //
// ./website/store/modules/post_order.js